import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { DSFieldRecord } from '../public/core';
import { conditionsGrouping } from './addingCondition';
import { isEventBasedFilterFamily } from '../strategy/eventBasedFilters';
import PortalIdParser from 'PortalIdParser';
const IMPORT_PREFIX = 'IMPORT-';
const ENABLED_OBJECT_TYPE_IDS_FOR_IMPORT = [CONTACT_TYPE_ID, COMPANY_TYPE_ID, DEAL_TYPE_ID];
const getViewImportURL = (importId, objectTypeId) => {
  if (!ENABLED_OBJECT_TYPE_IDS_FOR_IMPORT.includes(objectTypeId)) {
    return null;
  }
  const portalId = PortalIdParser.get();
  const filterOptions = JSON.stringify([{
    operator: 'IN',
    property: '_inbounddbio.importid_',
    values: [importId]
  }]);
  return `/contacts/${portalId}/objects/${objectTypeId}/views/all/list?filters=${encodeURIComponent(filterOptions)}`;
};
export const getHrefForAsset = (filterFamily, field) => {
  const isNotAnAsset = !conditionsGrouping.isAssetMembershipFilterFamily(filterFamily) && !isEventBasedFilterFamily(filterFamily);
  if (!DSFieldRecord.isDSFieldRecord(field) || isNotAnAsset) {
    return null;
  }
  if (field.type.startsWith(IMPORT_PREFIX)) {
    const objectTypeId = field.type.replace(IMPORT_PREFIX, '');
    return getViewImportURL(field.name, objectTypeId);
  }
  return field.url;
};